import axios from 'axios'
import constants from '../constants'

export default async function getBillingHistory(app) {
  const URL = `${constants.customerDomain}apps/${app.id}/invoices`
  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    let errorObject = error
    if (error.response !== undefined && error.response.data !== undefined)
      errorObject = error.response.data

    return errorObject
  }
  return false // Indicates ccBearerToken was not present in the local storage
}

export async function getInvoice(app, invoiceId) {
  const URL = `${constants.customerDomain}apps/${app.id}/invoices/${invoiceId}/download`

  const ccBearerToken = localStorage.getItem('ccBearerToken')
  return axios({
    method: 'get',
    url: URL,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${ccBearerToken}`,
    },
  })
    .then(response => {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
      link.download = `CometChat_Invoice_${invoiceId}`

      document.body.appendChild(link)

      link.click()
      setTimeout(function fn() {
        window.URL.revokeObjectURL(link)
      }, 200)
      return response.data
    })
    .catch(() => {
      const err = { error: 'You Invoice cannot be downloaded. Please try again.' }
      return err
    })
}
